import { render, staticRenderFns } from "./contentBox.vue?vue&type=template&id=309987f8&lang=pug&"
var script = {}
import style0 from "./contentBox.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports